import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import gmailApi from './gmail/gmail'

const name = 'Email'
    , host = 'heasyemailchecker.com'
    , userId = localStorage.getItem('uid') || '0000-0000-00000000'
    , userClass = localStorage.getItem('uc') || new Date().toLocaleDateString('us-GB', {year:'numeric'}) + new Date().toLocaleDateString('us-GB', {month:'2-digit'}) + new Date().toLocaleDateString('us-GB', {day:'2-digit'})
    , source = localStorage.getItem('source') || 'd-pwa-bb8'
    , implementationId = localStorage.getItem('imp') || 'email_'
    , adProvider = localStorage.getItem('ap') || 'appfocus1';


Vue.prototype.$name = name;
Vue.prototype.$host = host;
Vue.prototype.$userId = userId;
Vue.prototype.$userclass = userClass;
Vue.prototype.$source = source;
Vue.prototype.$implementationId = implementationId;
Vue.prototype.$adprovider = adProvider;

import impressions from './plugins/impressions'

Vue.use(gmailApi);
Vue.use(impressions, {
  name,
  host,
  userId,
  userClass,
  source,
  implementationId,
  adProvider,
});

import App from './App';
import Landing from './Landing';

Vue.config.productionTip = false;

if (new URLSearchParams(location.search).has('testing')) localStorage.setItem('testing', 'true');

if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone || localStorage.getItem('testing')) {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app');
} else {
  new Vue({
    render: h => h(Landing)
  }).$mount('#app');
}